import type {
  ChromaVectorSyncRunResult,
  ChromaVectorSyncTarget,
  ChromaVectorSyncTargetList,
} from "../types";

export type ChromaVectorSyncTargetRaw = {
  target_key: string;
  target_name: string;
  description: string;
  external_path: string;
  supports_rebuild: boolean;
};

export type ChromaVectorSyncTargetListRaw = {
  items: ChromaVectorSyncTargetRaw[];
};

export type ChromaVectorSyncRunResultRaw = {
  target_key: string;
  target_name?: string;
  status: "completed" | "blocked";
  external_url?: string;
  message: string;
  external_status_code?: number | null;
  external_payload?: unknown;
};

/** 映射 Chroma 向量库同步对象列表。 */
export function mapChromaVectorSyncTargetList(
  raw: ChromaVectorSyncTargetListRaw,
): ChromaVectorSyncTargetList {
  return {
    items: (raw.items ?? []).map(mapChromaVectorSyncTarget),
  };
}

/** 映射 Chroma 向量库同步执行结果。 */
export function mapChromaVectorSyncRunResult(
  raw: ChromaVectorSyncRunResultRaw,
): ChromaVectorSyncRunResult {
  return {
    targetKey: raw.target_key,
    targetName: raw.target_name ?? "",
    status: raw.status,
    externalUrl: raw.external_url ?? "",
    message: raw.message,
    externalStatusCode: raw.external_status_code,
    externalPayload: raw.external_payload,
  };
}

/** 映射 Chroma 向量库同步对象。 */
function mapChromaVectorSyncTarget(raw: ChromaVectorSyncTargetRaw): ChromaVectorSyncTarget {
  return {
    targetKey: raw.target_key,
    targetName: raw.target_name,
    description: raw.description,
    externalPath: raw.external_path,
    supportsRebuild: raw.supports_rebuild,
  };
}
